import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ServerService} from "./ServerService";

@Injectable({
  providedIn: 'root'
})
export class EmpresaService extends  ServerService {
  constructor(public http: HttpClient) {
      super(http)
  }

  atualizeEnviarLinksBotao(empresa: any) {
    return this.http.put('/empresas/atualizeEnviarLinksBotao', {
      id: empresa.id,
      enviarLinksBotao: empresa.enviarLinksBotao
    })
      .toPromise();
  }

  atualizeBotAtivo(empresa: any) {
    return this.http.put('/empresas/atualizeBotAtivo', {
      id: empresa.id,
      dominio: empresa.dominio,
      cardapio: empresa.cardapio
    })
      .toPromise();
  }

  salveNovaLocalizacao(empresa: any, latitude: string, longitude: string) {
    return this.http.put('/empresas/atualizeLocalizacao', {
      id: empresa.id,
      latitude: latitude,
      longitude:  longitude
    })
      .toPromise();
  }

  altereAceitarPedido(aceitarAutomatico: boolean){
    return this.facaPut('/empresas/pedidos/aceitar/auto', {aceitarAutomatico: aceitarAutomatico})
  }

  salveIntegracaoIfood(empresa: any, integracao: any){
    return this.facaPost('/ifood/' + empresa.id + '/integracao/ifood', integracao);
  }

  removaIntegracaoIfood(integracaoIfood: any){
    return this.facaPost('/ifood/integracao/ifood/remova/' + integracaoIfood.id, {});
  }

  desativeIntegracaoIfood(integracaoIfood: any){
    return this.facaPost('/ifood/integracao/ifood/desative/' + integracaoIfood.id, {});
  }

  ativeIntegracaoIfood(integracaoIfood: any){
    return this.facaPost('/ifood/integracao/ifood/ative/' + integracaoIfood.id, {});
  }


  atualizeIntegracaoIfood(integracao: any){
    return this.facaPost('/ifood/integracao/atualize', integracao);
  }

  autorizeNovaLoja(dados: any){
    return this.facaPost('/ifood/autorizacao/confirme', dados);
  }
  gereLinkAtivacaoIfood(app: string){
    return this.facaPost('/ifood/autorizacao/gere', { app: app});
  }

  sincronizeFormasPagamentoIfood(){
    return this.facaPost('/ifood/formaspagamento/sincronize', {});
  }

  sincronizeFormasPagamentoMeucardapioPay(provedor: string = 'tuna') {
    const url = provedor === 'cellcoin' ?
      '/cellcoinpay/me/sincronize/pagamentos' :
      '/tunapay/me/sincronize/pagamentos';

    return this.obtenha(url, {});
  }

  obtenhaStatusPagamentosCellcoin(sincronizarCredenciamentoCartao: boolean = false) {
    const params: any = {};

    if(sincronizarCredenciamentoCartao)
      params.sincronizarCredenciamentoCartao = 'true';

    return this.obtenha('/cellcoinpay/me/pagamentos/status', params);
  }

  liberePagamentoPixCellcoin() {
    return this.facaPost('/cellcoinpay/me/pagamentos/pix/liberar', {});
  }

  liberePagamentoCartaoCellcoin(parametrosCredenciamento: any = {}) {
    return this.facaPost('/cellcoinpay/me/pagamentos/cartao/liberar', parametrosCredenciamento || {});
  }

  listeWebhooksCellcoin(host: string) {
    return this.obtenha('/cellcoinpay/me/webhooks', {host: host || ''});
  }

  salveWebhookCellcoin(key: string, host: string) {
    return this.facaPost('/cellcoinpay/me/webhooks/' + key, {host: host || ''});
  }

  removaWebhookCellcoin(key: string, host: string) {
    const query = encodeURIComponent(host || '');
    return this.remova('/cellcoinpay/me/webhooks/' + key + '?host=' + query, {});
  }

  listeWebhooksOnboardingCellcoin() {
    return this.obtenha('/cellcoinpay/me/proposta/webhooks/onboarding', {});
  }

  obtenhaArquivosPropostaCellcoin() {
    return this.obtenha('/cellcoinpay/me/proposta/arquivos', {});
  }

  obtenhaDetalhesContaCellcoin() {
    return this.obtenha('/cellcoinpay/me/conta/detalhes', {});
  }

  listeTransferenciasPixContaCellcoin(filtros: any = {}) {
    return this.obtenha('/cellcoinpay/me/conta/pix-transferencias', filtros || {});
  }

  listeChavesSalvasTransferenciaPixContaCellcoin() {
    return this.obtenha('/cellcoinpay/me/conta/pix-transferencias/chaves', {});
  }

  inicieProtecaoCsrfTransferenciaPixContaCellcoin() {
    return this.obtenha('/cellcoinpay/me/conta/pix-transferencias/autorizacao/csrf', {});
  }

  consulteDestinoTransferenciaPixContaCellcoin(homologacao: boolean = false,
                                                chave: string = null,
                                                salvarChave: boolean = false,
                                                tokenCsrf: string = '') {
    return this.facaPostTransferenciaPixCellcoin(
      '/cellcoinpay/me/conta/pix-transferencias/destino',
      {homologacao, chave, salvarChave},
      tokenCsrf
    );
  }

  soliciteAutorizacaoTransferenciaPixContaCellcoin(tokenCsrf: string) {
    return this.facaPostTransferenciaPixCellcoin(
      '/cellcoinpay/me/conta/pix-transferencias/autorizacao/code', {}, tokenCsrf
    );
  }

  valideAutorizacaoTransferenciaPixContaCellcoin(codigo: string, tokenCsrf: string) {
    return this.facaPostTransferenciaPixCellcoin(
      '/cellcoinpay/me/conta/pix-transferencias/autorizacao/validate', {codigo}, tokenCsrf
    );
  }

  canceleAutorizacaoTransferenciaPixContaCellcoin(transferenciaId: any = null,
                                                   tokenCsrf: string = '') {
    return this.facaPostTransferenciaPixCellcoin(
      '/cellcoinpay/me/conta/pix-transferencias/autorizacao/cancel',
      {transferenciaId},
      tokenCsrf
    );
  }

  prepareTransferenciaPixContaCellcoin(valor: number, chave: string = null,
                                       tokenCsrf: string = '') {
    return this.facaPostTransferenciaPixCellcoin(
      '/cellcoinpay/me/conta/pix-transferencias/prepare', {valor, chave}, tokenCsrf
    );
  }

  testeChaveRejeicaoTransferenciaPixContaCellcoin(valor: number, tokenCsrf: string = '') {
    return this.facaPostTransferenciaPixCellcoin(
      '/cellcoinpay/me/conta/pix-transferencias/homologacao/testar-chave-rejeicao',
      {valor},
      tokenCsrf
    );
  }

  confirmeTransferenciaPixContaCellcoin(id: any, codigo: string, tokenCsrf: string = '') {
    return this.facaPostTransferenciaPixCellcoin(
      '/cellcoinpay/me/conta/pix-transferencias/' + encodeURIComponent(id) + '/confirm',
      {codigo},
      tokenCsrf
    );
  }

  private facaPostTransferenciaPixCellcoin(endpoint: string, dados: any,
                                            tokenCsrf: string): Promise<any> {
    return this.http.post(endpoint, dados, {
      headers: {'X-CSRF-Token': String(tokenCsrf || '')}
    }).toPromise().then(this.retorno).catch(this.handleError);
  }

  consulteStatusTransferenciaPixContaCellcoin(id: any) {
    return this.obtenha(
      '/cellcoinpay/me/conta/pix-transferencias/' + encodeURIComponent(id) + '/status',
      {}
    );
  }

  acompanheTransferenciaPixContaCellcoin(id: any) {
    return this.obtenha(
      '/cellcoinpay/me/conta/pix-transferencias/' + encodeURIComponent(id) + '/acompanhamento',
      {}
    );
  }

  obtenhaExtratoContaCellcoin(filtros: any) {
    return this.obtenha('/cellcoinpay/me/conta/extrato', filtros || {});
  }

  obtenhaConsolidadoContaCellcoin(filtros: any) {
    return this.obtenha('/cellcoinpay/me/conta/consolidado', filtros || {});
  }

  soliciteRelatorioRecebiveisContaCellcoin(filtros: any) {
    return this.facaPost('/cellcoinpay/me/conta/recebiveis', filtros || {});
  }

  listeSolicitacoesRelatorioRecebiveisContaCellcoin() {
    return this.obtenha('/cellcoinpay/me/conta/recebiveis/solicitacoes', {});
  }

  consulteRelatorioRecebiveisContaCellcoin(requestId: string) {
    return this.obtenha('/cellcoinpay/me/conta/recebiveis/' + encodeURIComponent(requestId), {});
  }

  listeClientesContaCellcoin(filtros: any) {
    return this.obtenha('/cellcoinpay/me/conta/clientes', filtros || {});
  }

  listeCobrancasPixContaCellcoin(filtros: any) {
    return this.obtenha('/cellcoinpay/me/conta/cobrancas/pix', filtros || {});
  }

  listeCobrancasCartaoContaCellcoin(filtros: any) {
    return this.obtenha('/cellcoinpay/me/conta/cobrancas/cartao', filtros || {});
  }

  listeOpcoesReplayWebhooksCellcoin() {
    return this.obtenha('/cellcoinpay/me/webhooks-replay/opcoes', {});
  }

  listeReplayWebhooksCellcoin(key: string) {
    return this.obtenha('/cellcoinpay/me/webhooks-replay/' + encodeURIComponent(key), {});
  }

  reenvieReplayWebhookCellcoin(key: string, webhookId: string, filter: any) {
    return this.facaPut(
      '/cellcoinpay/me/webhooks-replay/' + encodeURIComponent(key) + '/' + encodeURIComponent(webhookId),
      {filter: filter || {}}
    );
  }

  listeChargebacksCellcoin() {
    return this.obtenha('/cellcoinpay/me/chargebacks', {});
  }

  importeChargebackCellcoin(chargebackId: any) {
    return this.facaPost('/cellcoinpay/me/chargebacks/' + encodeURIComponent(chargebackId) + '/importar', {});
  }

  desativeContaCellcoin() {
    return this.facaPost('/cellcoinpay/me/conta/desativar', {});
  }

  ativeContaCellcoin() {
    return this.facaPost('/cellcoinpay/me/conta/ativar', {});
  }

  encerreContaCellcoin() {
    return this.facaPost('/cellcoinpay/me/conta/encerrar', {});
  }

  obtenhaAtivacaoPendente(empresa: any){
    return this.http.get('/ifood/autorizacao/' + empresa.id , { })
      .toPromise().then(this.retorno).catch(this.handleError);

  }

  sincronizeFormasPagamentoKeeta(){
    return this.facaPost('/keeta/formaspagamento/sincronize', {});
  }

  obtenhaLojasAtivar(authId: any){
    return this.http.get(`/keeta/autorizacao/${authId}/lojas` , { })
      .toPromise().then(this.retorno).catch(this.handleError);

  }

  obtenhaAppInfo( ){
    return this.http.get(`/keeta/me/appinfo` , { })
      .toPromise().then(this.retorno).catch(this.handleError);

  }

  gereLinkAtivacaoKeeta(){
    return this.facaPost('/keeta/autorizacao/gere', {});
  }

  confirmeIntegracaoLojaKeeta(dados: any){
    return this.facaPost('/keeta/autorizacao/confirme' , dados);
  }

  removaIntegracaoKeeta(integracaoIfood: any){
    return this.facaPost('/keeta/integracao/remova/' + integracaoIfood.id, {});
  }

  abrirLojaKeeta(){
    return this.facaPost('/keeta/loja/abrir', {});
  }

  fecharLojaKeeta(){
    return this.facaPost('/keeta/loja/fechar', {});
  }

  gereLinkAtivacao99Food(){
    return this.facaPost('/99food/autorizacao/gere', {});
  }

  confirmeIntegracaoLoja99Food(dados: any){
    return this.facaPost('/99food/autorizacao/confirme', dados);
  }

  removaIntegracao99Food(integracao: any){
    return this.facaPost('/99food/integracao/remova/' + integracao.id, {});
  }

  atualizePublicacaoCatalogo99Food(id: number, publicacaoCatalogoHabilitada: boolean) {
    return this.facaPost('/99food/integracao/atualize', {id, publicacaoCatalogoHabilitada});
  }

  abrirLoja99Food(loja: any){
    return this.facaPost('/99food/loja/abrir', loja);
  }

  fecharLoja99Food(loja: any){
    return this.facaPost('/99food/loja/fechar', loja);
  }

  obtenhaLojasAtivar99Food(authId: any){
    return this.http.get(`/99food/autorizacao/${authId}/lojas`, { })
      .toPromise().then(this.retorno).catch(this.handleError);
  }

  sincronizeFormasPagamento99Food(){
    return this.facaPost('/99food/formaspagamento/sincronize', {});
  }

  altere99FoodMetodoConfirmacao(dados: any){
    return this.facaPost('/99food/loja/confirmacao/metodo', dados);
  }

  altere99FoodStatusAutomatico(dados: any){
    return this.facaPost('/99food/loja/status/automatico', dados);
  }

  altere99FoodAceitarCancelamento(integracao: any){
    return this.facaPost('/99food/loja/aceitarCancelamento', integracao);
  }

  altere99FoodAceitarReembolso(integracao: any){
    return this.facaPost('/99food/loja/aceitarReembolso', integracao);
  }


  listeFormasAtivasMesa(){
    return this.http.get('/integracaoerp/formaspagamento/mesas/ativas' , { })
      .toPromise().then(this.retorno).catch(this.handleError);

  }

  listeBanco() {
    return this.http.get('/api/bancos', { })
      .toPromise().then(this.retorno).catch(this.handleError);
  }

  registreEmpresaTuna(empresaTuna: any) {
    return this.facaPost('/tunapay/empresa/registre', empresaTuna);
  }

  registreEmpresaCellcoin(proposta: any = {}) {
    return this.facaPost('/cellcoinpay/empresa/registre', proposta);
  }

  migreEmpresaCellcoin(proposta: any = {}) {
    return this.facaPost('/cellcoinpay/me/migre', proposta);
  }

  concluaMigracaoCellcoin() {
    return this.facaPost('/cellcoinpay/me/migracao/concluir', {});
  }

  verifiqueRetornoRegistroTuna() {
    return this.facaPost('/tunapay/me/merchant/sincronize', {});
  }

  verifiqueRetornoRegistroCellcoin() {
    return this.facaPost('/cellcoinpay/me/proposta/sincronize', {});
  }

  crieNovaPropostaCellcoin() {
    return this.facaPost('/cellcoinpay/me/proposta/nova', {});
  }

  listePropostasCellcoin() {
    return this.obtenha('/cellcoinpay/me/propostas', {});
  }

  obntehaMerchantTuna() {
    return this.obtenha('/tunapay/me/merchant/dto', {});
  }

  obtenhaPropostaCellcoin() {
    return this.obtenha('/cellcoinpay/me/proposta/dto', {});
  }

  obtenhaConfiguracaoAtivacaoMeucardapioPay() {
    return this.obtenha('/cellcoinpay/me/ativacao/configuracao', {});
  }

  consulteCnpjCellcoin(cnpj: string) {
    const documento = String(cnpj || '').replace(/\D/g, '');

    return this.obtenha('/cellcoinpay/me/cnpj/' + documento, {});
  }

  obntehaPadraoMCIPay(provedor: string = 'tuna') {
    const rota = provedor === 'cellcoin' ?
      '/cellcoinpay/meucardapiopay/padrao' :
      '/tunapay/meucardapiopay/padrao';

    return this.obtenha(rota, {});
  }
}
